export default __webpack_public_path__ + "static/ETH-9c85e9cb008b01eef7cb8dc2cf1f6674.jpg";